import { createContext, useContext } from "react";
import { Layer } from "../../../types";

type LayerContextType = { layer: Layer };
const LayerContext = createContext<LayerContextType>({} as LayerContextType);

export const LayerContextProvider = ({ layer, children }: { layer: Layer; children: React.ReactNode }) => (
  <LayerContext.Provider value={{ layer }}>{children}</LayerContext.Provider>
);

export const useLayerContext = <T extends Layer = Layer>(): { layer: T } => {
  const context = useContext(LayerContext);
  if (!context) {
    throw new Error("useLayerContext must be used within a LayerContextProvider");
  }
  return { layer: context.layer as T };
};
